import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Header from "../../../Common/header";
import OfferCard from "../../../components/Offers/index";
import axios from "../../../utils/http";
import { OFFER_SUMMARY } from "../../../utils/urls";
import "./style.css";
import Loader from "../../../Common/Loader";
// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';
import { Button } from "@material-ui/core";

function AvailableOffers() {
  const history = useHistory();
  const [loader, setLoader] = useState(true);

  const historyState: any = history.location.state;
  const offers: any[] =
    historyState == undefined
      ? history.push("/dashboard")
      : historyState.cd_loans;
  useEffect(() => {
    axios
      .post(OFFER_SUMMARY, {
        cd_application_id: historyState.application_id,
      })
      .then((res) => {
        setLoader(false);
        history.push("/offer-summery", {
          offer: res.data.results.offer_details,
          product:res.data.results.product_details,
          application_id: historyState.application_id,
        });
      })
      .catch((error) => {
        setLoader(false);
        console.log(
          error.response.data.errors?.detail || error.response.data.errors
        );
      });
  }, []);

  const reload = () => {
    window.location.reload();
  };

  return loader ? (
    <Loader loading={true} />
  ) : (
    <Box className="newCard" sx={{ mt: 7, p: 2 }}>
      <div>
        <Header pageName="Available offers" />
      </div>

      <div className="offerCards">
        {offers?.map((i, idx) => {
          return (
            <div>
              <OfferCard properties={i} />
            </div>
          );
        })}
      </div>
      {/* <div className="reload-container">
        <span>&#8635;</span>
      </div> */}

      <Box sx={{ mt: 5 }}>
        <Button
          variant="contained"
          color="secondary"
          className="redButton"
          onClick={reload}
        >
          Reload
        </Button>
      </Box>
    </Box>
  );
}

export default AvailableOffers;
